<template>
    <div>
        <div class="relative">
            <div class="ds-field-label pb-1" v-if="label">
                <slot></slot>
            </div>
            <input :type="type" :maxlength="maxLength"

                class="ds-field-input max-w-lg px-3"
                :placeholder
                :class="{ 'pl-8': iconLeft, 'pr-8': $slots.right, 'opacity-50': disabled }" :value="modelValue"
                :disabled
                :readonly
                @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)">
            <icon v-if="iconLeft" class="absolute top-1 left-1">
                <slot name="left"></slot>
            </icon>
            <span v-if="$slots.right" class="absolute right-1 bottom-[5px]">
                <slot name="right"></slot>
            </span>
        </div>
    </div>
</template>

<script setup lang="ts">
import { toRefs } from 'vue';

const props = defineProps({
    type: {
        type: String,
        default: 'text'
    },
    modelValue: {
        type: [String, Number],
        default: ''
    },
    iconLeft: {
        type: Boolean,
        default: false
    },
    label: {
        type: Boolean,
        default: true
    },
    maxLength: {
        type: String,
        required: false
    },
    placeholder: {
        type: String,
        required: false
    },
    disabled: {
        type: Boolean,
        required: false
    },
    readonly: {
        type: Boolean,
        required: false
    }
})
defineEmits(['update:modelValue'])

const { type } = toRefs(props)

</script>
